import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import NextLink from 'next/link';
import React from 'react';
export interface Href {
  pathname: string;
  query?: Record<string, string | string[] | number | boolean | undefined>;
}
export type LinkProps = Omit<MuiLinkProps, 'href' | 'variant'> & {
  disabled?: boolean;
  href: string | Href;
  isExternal?: boolean;
  prefetch?: boolean;
};
export const Link: React.FC<LinkProps> = ({
  children,
  disabled,
  href,
  isExternal,
  prefetch,
  ...linkProps
}: LinkProps): React.ReactElement<LinkProps> | LinkProps['children'] => {
  if (disabled) {
    return children;
  }
  return isExternal ? <MuiLink href={String(href)} {...linkProps} data-sentry-element="MuiLink" data-sentry-component="Link" data-sentry-source-file="index.tsx">
      {children}
    </MuiLink> : <NextLink href={href} legacyBehavior passHref prefetch={prefetch} data-sentry-element="NextLink" data-sentry-component="Link" data-sentry-source-file="index.tsx">
      <MuiLink {...linkProps} data-sentry-element="MuiLink" data-sentry-source-file="index.tsx">{children}</MuiLink>
    </NextLink>;
};
export default Link;